<template>
  <div class="currency">
    <v-row>
      <v-col cols="12" sm="6">
        <div class="areaTitle">
          <h2>Currencies</h2>
          <v-btn color="primary" depressed @click.stop="onAddNewCurency" class="mr-2">
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add new curreny
          </v-btn>
        </div>
        <v-card class="pa-2 currenciesList" outlined tile>
          <v-data-table
            :headers="currencyHeaders"
            v-model="selectedCurrencyRows"
            :items="currencies"
            :items-per-page="-1"
            :loading="isLoadingCurrencies"
            :single-select="true"
            item-key="currency"
            @click:row="rowClick"
            dense
          >
            <template v-slot:item.Actions="{ item }">
              <div class="actionBtnContainer">
                <v-btn
                  color="primary"
                  depressed
                  @click.stop="onEditCurrency(item)"
                  small
                  class="actionBtn mr-2"
                >
                  Edit
                </v-btn>
                <v-btn
                  color="error"
                  depressed
                  @click.stop="onDeleteCurrency(item)"
                  small
                  class="actionBtn mr-2"
                  ><v-icon small> mdi-delete </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6">
        <h2>Exchange Rate</h2>
        <v-alert v-if="!selectedCurrency" outlined dense type="info">
          Please select currency first or add the new.
        </v-alert>
        <div v-else class="exchangeRate">
          <div class="exchangeRateFilter">
            <div class="filterItem selectedCyrrency">
              Base Currency: {{ selectedCurrency.Name }}
            </div>
            <div class="filterItem">
              <v-select
                v-model="foreignCurrency"
                :items="availableForeignCurrencies"
                label="Foreign Currency"
                item-text="Name"
                item-value="currency"
                attach
                class="pt-4"
              ></v-select>
            </div>
            <!-- <div class="filterItem">
              <v-btn
                outlined
                color="primary"
                :disabled="!foreignCurrency"
                @click="onLoadExchangeRate"
                >Load data</v-btn
              >
            </div> -->
            <v-btn
              v-if="foreignCurrency"
              color="primary"
              depressed
              @click.stop="onAddNewExchangeRate"
              class="mr-2 float-right"
            >
              <v-icon class="mr-2">mdi-plus</v-icon>
              Add new
            </v-btn>
          </div>
          <v-data-table
            v-if="foreignCurrency"
            :headers="exchangeRateHeaders"
            v-model="selectedExchangeRateRows"
            :items="exchangeRates"
            :loading="isLoadingExchangeRates"
            :items-per-page="-1"
            item-key="ExchangeDateString"
            dense
          >
            <template v-slot:item.Actions="{ item }">
              <div class="actionBtnContainer">
                <v-btn
                  color="primary"
                  depressed
                  @click.stop="onEditExchangeRate(item)"
                  small
                  class="actionBtn mr-2"
                >
                  Edit
                </v-btn>
                <v-btn
                  color="error"
                  depressed
                  @click.stop="onDeleteExchangeRate(item)"
                  small
                  class="actionBtn mr-2"
                  ><v-icon small> mdi-delete </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="currencyDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Currency</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="editedCurrency">
            <v-form
              ref="currencyForm"
              v-model="isCurrencyFormValid"
              lazy-validation
              class="currencyForm"
            >
              <div>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedCurrency.currency"
                    label="Currency"
                    :readonly="!isNewCurrency"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </div>
              <div>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedCurrency.Name"
                    label="Name"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </div>
              <div>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedCurrency.CurrencySymbol"
                    label="Symbol"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="onCancelCurrencyDialog"> Cancel </v-btn>
          <v-btn
            color="primary"
            depressed
            @click="onSaveCurrencyDialog"
            :disabled="!isCurrencyFormValid"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exchangeRateDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Exchange rate</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="editedExchangeRate">
            <v-form
              ref="exchangeRateForm"
              v-model="isExchangeRateFormValid"
              lazy-validation
              class="exchangeRateForm"
            >
              <DatePicker
                v-model="editedExchangeRate.ExchangeDate"
                label="Exchange date"
                :readonly="!isNewExchangeRate"
                :rules="[rules.required]"
              />
              <v-text-field
                v-model="editedExchangeRate.DirectRate"
                label="Exchange Rate"
                type="number"
                min="0"
                :step="0.0001"
                :rules="[rules.required]"
                class="mt-3"
              ></v-text-field>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="onCancelExchangeRateDialog"> Cancel </v-btn>
          <v-btn
            color="primary"
            depressed
            @click="onSaveExchangeRate"
            :disabled="!isExchangeRateFormValid"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Dialog ref="confirmation"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
import DatePicker from '@/components/formControls/DatePicker.vue';

export default {
  name: 'Currency',
  components: { DatePicker, Dialog },
  data: () => ({
    isLoadingCurrencies: false,
    isLoadingExchangeRates: false,
    currencies: [],
    selectedCurrencyRows: [],
    selectedExchangeRateRows: [],
    editedCurrency: null,
    isNewCurrency: false,
    currencyHeaders: [
      { text: 'Currency', value: 'currency' },
      { text: 'Name', value: 'Name' },
      { text: 'Symbol', value: 'CurrencySymbol' },
      { text: 'Actions', value: 'Actions' },
    ],
    exchangeRateHeaders: [
      { text: 'Exchange date', value: 'ExchangeDateString' },
      { text: 'Exchange rate', value: 'DirectRate' },
      { text: 'Actions', value: 'Actions' },
    ],
    currencyDialog: false,
    exchangeRateDialog: false,
    foreignCurrency: null,
    exchangeRates: [],
    editedExchangeRate: null,
    isNewExchangeRate: false,
    rules: {
      required: (value) => !!value || 'Required.',
    },
    isCurrencyFormValid: false,
    isExchangeRateFormValid: false,
  }),
  created() {
    this.getCurrencyList();
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    selectedCurrency() {
      return this.selectedCurrencyRows && this.selectedCurrencyRows.length > 0
        ? this.selectedCurrencyRows[0]
        : null;
    },
    availableForeignCurrencies() {
      const result = [];
      const selected = this.selectedCurrency;
      if (this.currencies && this.currencies.length > 0 && selected) {
        this.currencies.forEach((x) => {
          if (x.currency != selected.currency) result.push(x);
        });
      }

      return result;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },
  watch: {
    foreignCurrency: function () {
      if (this.foreignCurrency) this.getExchangeRates();
      else this.exchangeRates = null;
    },
  },
  methods: {
    onAddNewCurency() {
      this.editedCurrency = {
        currency: null,
        Name: null,
        CurrencySymbol: null,
      };
      this.isNewCurrency = true;
      this.currencyDialog = true;
    },
    rowClick(item, row) {
      row.select(true);
      this.foreignCurrency = null;
    },
    onEditCurrency(item) {
      this.editedCurrency = Object.assign({}, item);
      this.isNewCurrency = false;
      this.currencyDialog = true;
    },
    async onDeleteCurrency(item) {
      try {
        await this.$refs.confirmation.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteCurrency(item.currency);
      } catch (err) {
        console.log(err);
      }
    },
    onCancelCurrencyDialog() {
      this.currencyDialog = false;
    },
    onSaveCurrencyDialog() {
      const isFormValid = this.$refs.currencyForm.validate();
      if (isFormValid) {
        this.updateCurrency();
      }
    },
    onAddNewExchangeRate() {
      this.editedExchangeRate = {
        Id: 0,
        BaseCurrency: this.selectedCurrency.currency,
        ForeignCurrency: this.foreignCurrency,
        ExchangeDate: null,
        DirectRate: 0,
        ExchangeDateString: null,
      };
      this.isNewExchangeRate = true;
      this.exchangeRateDialog = true;
    },
    onLoadExchangeRate() {
      this.getExchangeRates();
    },
    onEditExchangeRate(item) {
      this.editedExchangeRate = Object.assign({}, item);
      this.exchangeRateDialog = true;
      this.isNewExchangeRate = false;
    },
    async onDeleteExchangeRate(item) {
      try {
        await this.$refs.confirmation.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteExchangeRate(item);
      } catch (err) {
        console.log(err);
      }
    },
    onCancelExchangeRateDialog() {
      this.exchangeRateDialog = false;
    },
    onSaveExchangeRate() {
      const isFormValid = this.$refs.exchangeRateForm.validate();
      if (isFormValid) {
        if (this.isNewExchangeRate) this.insertExchangeRate(this.editedExchangeRate);
        else this.updateExchangeRate(this.editedExchangeRate);
      }
    },
    async getCurrencyList() {
      try {
        this.isLoadingCurrencies = true;
        let response = await this.$api.get('/Currency/GetCurrencyList');
        this.currencies = response.data;
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingCurrencies = false;
      }
    },

    async getExchangeRates() {
      try {
        var data = {
          params: {
            baseCurrency: this.selectedCurrency.currency,
            foreignCurrency: this.foreignCurrency,
          },
        };
        this.isLoadingExchangeRates = true;
        this.exchangeRates = [];
        let response = await this.$api.get('/Currency/GetExchangeRates', data);
        if (response.data) {
          this.exchangeRates = response.data;
        } else {
          this.$store.commit('setNotificationMessage', {
            type: 'error',
            text: 'Something going wrong',
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingExchangeRates = false;
      }
    },

    async updateCurrency() {
      try {
        const response = await this.$api.post('/Currency/UpdateCurrency', this.editedCurrency);
        const result = response.data;
        if (result.Value >= 0) {
          this.$store.commit('setNotificationMessage', {
            type: 'success',
            text: 'Currency was saved successfully',
          });
          this.currencyDialog = false;
          this.getCurrencyList();
        }
      } catch (err) {
        console.error(err);
      }
    },

    async deleteCurrency(currency) {
      try {
        let response = await this.$api.delete('/Currency/DeleteCurrency?currency=' + currency);
        var result = response.data;
        if (result.Value >= 0) {
          this.$store.commit('setNotificationMessage', {
            type: 'success',
            text: 'Currency was deleted successfully',
          });

          if (this.selectedCurrency && this.selectedCurrency.currency == currency)
            this.selectedCurrencyRows = [];
          this.getCurrencyList();
        }
      } catch (err) {
        console.error(err);
      }
    },

    async insertExchangeRate(item) {
      try {
        console.log(item);
        const response = await this.$api.post('/Currency/InsertExchangeRate', item);
        var result = response.data;
        if (result.Value >= 0) {
          this.$store.commit('setNotificationMessage', {
            type: 'success',
            text: 'Exchange rate was added successfully',
          });
          this.exchangeRateDialog = false;
          this.getExchangeRates();
        }
      } catch (err) {
        console.error(err);
      }
    },

    async updateExchangeRate(item) {
      try {
        const response = await this.$api.post('/Currency/UpdateExchangeRate', item);
        var result = response.data;
        if (result.Value >= 0) {
          this.$store.commit('setNotificationMessage', {
            type: 'success',
            text: 'Exchange rate was saved successfully',
          });
          this.exchangeRateDialog = false;
          this.getExchangeRates();
        }
      } catch (err) {
        console.error(err);
      }
    },

    async deleteExchangeRate(item) {
      try {
        let response = await this.$api.delete('/Currency/DeleteExchangeRate?Id=' + item.Id);
        var result = response.data;
        if (result.Value >= 0) {
          this.$store.commit('setNotificationMessage', {
            type: 'success',
            text: 'Exchange rate was deleted successfully',
          });
          this.getExchangeRates();
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
.currency {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;
}

.currenciesList .actionBtnContainer {
  display: flex;
  justify-content: flex-end;
}

.currency .areaTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.exchangeRateFilter .filterItem {
  display: inline-block;
  margin-right: 20px;
}

.exchangeRateFilter .selectedCyrrency {
  padding: 9px;
  background-color: #cbe9ff !important;
  color: #1571cb;
}

.filterItem .v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.exchangeRate .actionBtnContainer {
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="scss" scoped>
.formContainer {
  position: relative;
  height: 100%;

  .formFooter {
    bottom: 0;
    width: 100%;
    margin-top: 5px;

    position: sticky;
    background-color: white;
    padding: 8px 0 0 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btnContainer {
      display: flex;
    }
  }
}
</style>
